<template>
  <modal
    :show-modal="showModal"
    @close-modal="closeModal"
    width="35"
    title="Vehicle Particulars"
  >
    <div class="flex flex-col gap-4 my-3">
      <label class="">License & Registration Number</label>
      <input type="password" disabled class="input" />
      <label class="">Expiry Date</label>
      <el-date-picker
        v-model="vehicleParticular.expirydate"
        type="date"
        placeholder="Pick a date"
      >
      </el-date-picker>

      <hr class="mt-5 mb-3" />
      <div>
        <p>Uploaded Files</p>
        <div class="flex flex-row justify-between my-3">
          <div class="flex flex-row gap-2">
            <div class="my-auto">
              <img src="./pdf-icon.svg" alt="" />
            </div>
            <div>
              <p class="text-base font-semibold">license And Registration.pdf</p>
              <p class="text-success text-sm">
                license And Registration <span class="text-muted">258kb</span>
              </p>
            </div>
          </div>
          <base-button text="View" background="white" color="text-primary-yellow"></base-button>
        </div>
        <div class="flex flex-row justify-between my-3">
          <div class="flex flex-row gap-2">
            <div class="my-auto">
              <img src="./pdf-icon.svg" alt="" />
            </div>
            <div>
              <p class="text-base font-semibold">license And Registration.pdf</p>
              <p class="text-success text-sm">
                license And Registration <span class="text-muted">258kb</span>
              </p>
            </div>
          </div>
          <base-button text="View" background="white" color="text-primary-yellow"></base-button>
        </div>
        <div class="flex flex-row justify-between my-3">
          <div class="flex flex-row gap-2">
            <div class="my-auto">
              <img src="./pdf-icon.svg" alt="" />
            </div>
            <div>
              <p class="text-base font-semibold">license And Registration.pdf</p>
              <p class="text-success text-sm">
                license And Registration <span class="text-muted">258kb</span>
              </p>
            </div>
          </div>
          <base-button text="View" background="white" color="text-primary-yellow"></base-button>
        </div>
      </div>
      <div class="flex items-center mt-5 justify-end">
        <div class="cursor-pointer">
          <base-button text="Close" @click="closeModal"></base-button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: ["showModal"],
  data() {
    return {
      vehicleParticular: [],
    };
  },

  methods : {
    closeModal(){
      this.$emit("close-modal")
    }
  }
};
</script>

<style>
.entity-name {
  background: #dae8f6;
  padding: 0.5em;
  text-align: center;
}
</style>